import {
  IUser,
  IAircraftType,
  IFlightAircraft,
  IFlight,
  IGroundEvent,
  TimelineEvent,
  ICustomer,
  IFlightType,
  IDynamicQuery,
  IQueryArguments,
  IFlightFlag,
  IFilterOption,
  FlightRemovalType,
} from "@vmosolutions/oc-interfaces";
import _ from "lodash";

// Airport Retrieval
import { IAirportOption } from "src/redux/reducers/StructuresReducer"; //IAirportOptionMap
import { IDaysOfWeekOption } from "./Helpers";

// FLIGHT EVENT Search Filters
export const flightFilterOptions: IFilterOption[] = [
  {
    value: "f_flightNumber",
    label: "Flight #",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_origin",
    label: "Origin",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_destination",
    label: "Destination",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_departureGate",
    label: "Departure Gate",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_arrivalGate",
    label: "Arrival Gate",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_alternate",
    label: "Alternate",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledOff",
    label: "Scheduled Off",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledOn",
    label: "Scheduled On",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledOut",
    label: "Scheduled Out",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledIn",
    label: "Scheduled In",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualOff",
    label: "Actual Off",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualOn",
    label: "Actual On",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualOut",
    label: "Actual Out",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualIn",
    label: "Actual In",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_customer",
    label: "Customer",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_flightType",
    label: "Flight Type",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_removalType",
    label: "Removal Type",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_aircraft",
    label: "Aircraft",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_aircraftType",
    label: "Aircraft Type",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_flags",
    label: "Flight Flags",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_validation",
    label: "Validation Status",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_batchId",
    label: "Batch Id",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_createdBy",
    label: "Created By",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_createdAt",
    label: "Created At",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_modifiedBy",
    label: "Modified By",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_modifiedAt",
    label: "Modified At",
    type: "flights",
    searchValue: null,
  },
];

// GROUND EVENT Search filters
export const eventFilterOptions: IFilterOption[] = [
  {
    value: "g_location",
    label: "Location",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_title",
    label: "Title",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_scheduledStart",
    label: "Scheduled Start",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_scheduledEnd",
    label: "Scheduled End",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_actualStart",
    label: "Actual Start",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_actualEnd",
    label: "Actual End",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_eventType",
    label: "Event Type",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_aircraft",
    label: "Aircraft",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_batchId",
    label: "Batch Id",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_createdBy",
    label: "Created By",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_createdAt",
    label: "Created At",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_modifiedBy",
    label: "Modified By",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_modifiedAt",
    label: "Modified At",
    type: "groundEvents",
    searchValue: null,
  },
];

// BASIC SEARCH FILTERS - used in the timeline header.
const baseFlightFilterOptions: IFilterOption[] = [
  {
    value: "f_flightNumber",
    label: "Flight #",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_origin",
    label: "Origin",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_destination",
    label: "Destination",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledOff",
    label: "Scheduled Off",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledOn",
    label: "Scheduled On",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledOut",
    label: "Scheduled Out",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_scheduledIn",
    label: "Scheduled In",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualOff",
    label: "Actual Off",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualOn",
    label: "Actual On",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualOut",
    label: "Actual Out",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_actualIn",
    label: "Actual In",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_customer",
    label: "Customer",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_flightType",
    label: "Flight Type",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_aircraft",
    label: "Aircraft",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_aircraftType",
    label: "Aircraft Type",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_flags",
    label: "Flight Flags",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_batchId",
    label: "Batch Id",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_removalType",
    label: "Removal Type",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_createdBy",
    label: "Created By",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_createdAt",
    label: "Created At",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_modifiedBy",
    label: "Modified By",
    type: "flights",
    searchValue: null,
  },
  {
    value: "f_modifiedAt",
    label: "Modified At",
    type: "flights",
    searchValue: null,
  },
];

const baseEventFilterOptions: IFilterOption[] = [
  {
    value: "g_location",
    label: "Location",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_title",
    label: "Title",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_scheduledStart",
    label: "Scheduled Start",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_scheduledEnd",
    label: "Scheduled End",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_actualStart",
    label: "Actual Start",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_actualEnd",
    label: "Actual End",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_eventType",
    label: "Event Type",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_aircraft",
    label: "Aircraft",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_batchId",
    label: "Batch Id",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_createdBy",
    label: "Created By",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_createdAt",
    label: "Created At",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_modifiedBy",
    label: "Modified By",
    type: "groundEvents",
    searchValue: null,
  },
  {
    value: "g_modifiedAt",
    label: "Modified At",
    type: "groundEvents",
    searchValue: null,
  },
];

export const basicSearchFilters = {
  flightEvents: baseFlightFilterOptions,
  groundEvents: baseEventFilterOptions,
};

/**
 * Validation Status was a multi-select before ENG-690, so searches saved to a user's app
 * settings before that change may still hold an array of labels rather than a single label.
 * Read either shape so those saved filters keep working (for arrays, the first string entry is used).
 */
export const validationStatusOf = (searchValue: unknown): string | null => {
  if (Array.isArray(searchValue)) {
    const first = searchValue.find((v) => typeof v === "string");
    return first ?? null;
  }
  return typeof searchValue === "string" ? searchValue : null;
};

/**
 * Parse the current search filter format into the accepted query format for the new searchFlight endpoint.
 * return fields match the IFlight interface (non-optional fields only).
 * @param searchFilter -
 */
export const convertFilter2Query = (searchFilter: any, isFlight?: boolean): IDynamicQuery => {
  //input (Filter Search format) = { value: "f_flightNumber", label: "Flight #", type: "flights", searchValue: ["908", "112"]}
  //output (IDynamicQuery format) = { field: "flightNumber", condition: "EQ", value: [908, 112] };

  // Filters are reduced so that they are only returned if they contain valid values.
  const newFilters = searchFilter.reduce((queryFilters: IQueryArguments[], filter: any) => {
    const fieldName = isFlight ? filter.value.replace("f_", "") : filter.value.replace("g_", "");
    if (!filter.searchValue) {
      return null;
    }
    const queryObj: IQueryArguments = { field: fieldName, condition: "EQ", value: null };

    switch (fieldName) {
      case "flightNumber":
        queryObj.value = filter?.searchValue?.map((flightNumber: string) => parseInt(flightNumber));
        break;
      case "origin":
      case "destination":
      case "location":
      case "departureGate":
      case "arrivalGate":
        queryObj.value = filter?.searchValue;
        break;
      case "alternate":
        queryObj.field = "custom.alternate";
        queryObj.value = filter?.searchValue;
        break;
      case "scheduledOut":
      case "scheduledOff":
      case "scheduledOn":
      case "scheduledIn":
      case "actualOut":
      case "actualOff":
      case "actualOn":
      case "actualIn":
      case "scheduledStart":
      case "scheduledEnd":
      case "actualStart":
      case "actualEnd":
      case "createdAt":
      case "modifiedAt": {
        const from = filter?.searchValue?.minTime ? new Date(filter.searchValue.minTime)?.valueOf() : null;
        const to = filter?.searchValue?.maxTime ? new Date(filter.searchValue.maxTime)?.valueOf() : null;
        if (!!from && !!to) {
          queryObj.condition = "BT";
          queryObj.value = [from, to];
        } else if (!!from && !to) {
          queryObj.condition = "GT";
          queryObj.value = from;
        } else {
          queryObj.condition = "LT";
          queryObj.value = to;
        }
        // If supplied, apply selected days in it's rrule format.
        const byDays = filter?.searchValue?.daysOfWeek;
        const rRule: string =
          Array.isArray(byDays) && byDays.length > 0
            ? `BYDAY=${byDays.map((option: IDaysOfWeekOption) => option.rrule).toString()};`
            : null;
        if (rRule) {
          queryObj.rrule = rRule;
        }
        break;
      }
      case "customer": {
        const hasUnassigned = filter?.searchValue?.includes("unassigned");
        if (hasUnassigned) {
          return queryFilters;
        }
        queryObj.field = "customer._id";
        queryObj.value = filter?.searchValue;
        break;
      }
      case "flightType":
        queryObj.field = "flightType._id";
        queryObj.value = filter?.searchValue;
        break;
      case "eventType":
        queryObj.field = "eventType._id";
        queryObj.value = filter?.searchValue;
        break;
      case "aircraft":
        queryObj.field = "aircraft._id";
        queryObj.value = filter?.searchValue?.map((id: string) => (id === "unassigned" ? null : id));
        break;
      case "aircraftType":
        queryObj.field = "aircraft.aircraftType.title";
        queryObj.value = filter?.searchValue;
        break;
      case "flags":
        queryObj.field = "flags.title";
        queryObj.value = filter?.searchValue;
        break;
      case "batchId":
        queryObj.value = filter.searchValue.map((batchId: string) => batchId);
        break;
      case "validation": {
        // A flight's validation field mirrors the most recent entry of its log sheet's
        // validationHistory, so a sheet that had errors, was corrected and re-validated
        // clean reads as "no errors" here, which is what dispatch expects.
        // hasError is only stored when the reviewer touched the "Has Errors" checkbox, so a
        // clean first review leaves it absent. "No errors" must therefore be tested as NE
        // true; EQ false silently misses that whole population.
        const validationArgs: IQueryArguments[] = [];
        const validationStatus = validationStatusOf(filter?.searchValue);
        if (validationStatus === "Validated - No Errors") {
          validationArgs.push({ field: "validation.isValid", condition: "NE", value: null });
          validationArgs.push({ field: "validation.hasError", condition: "NE", value: true });
        } else if (validationStatus === "Validated - Errors") {
          validationArgs.push({ field: "validation.isValid", condition: "NE", value: null });
          validationArgs.push({ field: "validation.hasError", condition: "EQ", value: true });
        } else if (validationStatus === "Unvalidated") {
          // searchFlights swaps this exact arg for a check that also covers validation
          // recorded only against the content, so the value must stay an array of one null.
          validationArgs.push({ field: "validation.isValid", condition: "EQ", value: [null] });
        }
        if (validationArgs.length > 0) {
          // Sub-charters never receive a log sheet (OCN-194). NE true excludes them while
          // keeping flights whose embedded aircraft document has no subCharter field, and
          // flights with no aircraft assigned; EQ false silently dropped both.
          validationArgs.push({ field: "aircraft.subCharter", condition: "NE", value: true });
          queryFilters.push(...validationArgs);
        }
        break;
      }
      case "removalType":
        queryObj.value = filter.searchValue.map((type: { value: FlightRemovalType; label: string }) => type.value);
        break;
      case "title":
        queryObj.condition = "REGEX";
        queryObj.value = filter.searchValue;
        queryObj.field = "title";
        break;
      case "createdBy":
      case "modifiedBy":
        queryObj.field = fieldName;
        queryObj.value = filter?.searchValue;
        break;
      default:
    }
    if (queryObj?.value) {
      queryFilters.push(queryObj);
    }
    return queryFilters;
  }, []);

  if (isFlight) {
    //if you aren't searching for removed flights than add this filter
    if (!newFilters.find((filter: any) => filter.field === "removalType")) {
      newFilters.push({ condition: "EQ", field: "removalType", value: null });
    }
    return {
      queryArgs: newFilters,
      returnFields: [
        "_id",
        "aircraft",
        "aircraftType",
        "destination",
        "destinationTimezoneId",
        "flightNumber",
        "flightType",
        "origin",
        "originTimezoneId",
        "departureGate",
        "arrivalGate",
        "scheduledOut",
        "scheduledOff",
        "scheduledOn",
        "scheduledIn",
        "actualOut",
        "actualOff",
        "actualOn",
        "actualIn",
        "delays",
        "flags",
        "customer",
        // "departureMessages",
        // "arrivalMessages",
        "receivedDepartureMessage",
        "receivedArrivalMessage",
        "batchId",
        "validation",
        "removalType",
        // Temporal fields.
        "createdBy",
        "createdAt",
        "modifiedBy",
        "modifiedAt",
      ],
    };
  } else {
    return {
      queryArgs: newFilters,
      returnFields: [
        "_id",
        "aircraft",
        "aircraftType",
        "location",
        "title",
        "actualStart",
        "actualEnd",
        "scheduledStart",
        "scheduledEnd",
        "eventType",
        "batchId",
        // Temporal fields.
        "createdBy",
        "createdAt",
        "modifiedBy",
        "modifiedAt",
      ],
    };
  }
};

// Reduce the filters array to an objects to simplify filtering the dataset.
export const reducedFilter = (selectedFilter: any, allowMultiFilter: boolean): any => {
  const reducedFilter = selectedFilter.reduce((map: any, filter: IFilterOption) => {
    const { type, value, searchValue } = filter;
    const key = type === "flights" ? value.replace("f_", "") : value.replace("g_", "");
    switch (true) {
      case Array.isArray(searchValue) && searchValue.length > 0: // Array with Value
        map[key] = searchValue;
        break;
      case !!searchValue &&
        !Array.isArray(searchValue) &&
        searchValue.hasOwnProperty("minTime") &&
        searchValue.hasOwnProperty("maxTime"): // Date Range
        if (!!searchValue.minTime || !!searchValue.maxTime) {
          map[key] = searchValue;
        }
        break;
      case !!searchValue && !Array.isArray(searchValue): // Simple Value
        map[key] = searchValue;
        break;
      case !allowMultiFilter: // Used as single filter (almost makes value even when null)
        map[key] = searchValue;
        break;
      default:
        break;
    }
    return map;
  }, {});
  return reducedFilter;
};

/**
 * Accepts the user's input, the selected filter and the selected filter type and passes in the found flights
 * into an array and the first found flight into the callback function searchFlightByInput
 * which the callback function in the FlightTimeline.tsx will fire the jumpToInputtedFlight function
 * @param searchValue -
 * @param eventType - // used in the advanced filter search table
 */
export const filterEvents = (filters: any, events: TimelineEvent[], isFlight: boolean): TimelineEvent[] => {
  // Set default sets to their searched event list.
  let newFilteredEvents: TimelineEvent[] = events;

  // If there are no filters containing values, or no data to filter, return
  if (!filters || Object.keys(filters).length === 0 || newFilteredEvents.length === 0) {
    return [];
  }

  for (const key in filters) {
    const searchValue = filters[key];
    if (!key || !filters) {
      return [];
    }

    newFilteredEvents = newFilteredEvents.filter((event: IFlight | IGroundEvent) => {
      const typedKey = key as keyof typeof event;
      if (isFlight) {
        // FLIGHT EVENT
        switch (key) {
          case "flightNumber":
            return !!searchValue && Array.isArray(searchValue) && typeof event[typedKey] === "number"
              ? searchValue.includes(event[typedKey].toString())
              : false;
          case "origin":
          case "destination":
            if (!!searchValue && Array.isArray(searchValue)) {
              const airportIdents = searchValue.map((option: IAirportOption) => option.ident);
              return airportIdents.includes(event[typedKey]);
            }
            return false;
          case "scheduledOff":
          case "scheduledOn":
          case "scheduledOut":
          case "scheduledIn":
          case "actualOff":
          case "actualOn":
          case "actualOut":
          case "actualIn":
          case "createdAt":
          case "modifiedAt": {
            const dateValue = new Date(event[typedKey]);
            const { minTime, maxTime } = searchValue ?? {};
            if (minTime && maxTime) {
              return dateValue >= new Date(minTime) && dateValue <= new Date(maxTime);
            } else if (minTime && !maxTime) {
              return dateValue >= new Date(minTime);
            } else if (!minTime && maxTime) {
              return dateValue <= new Date(maxTime);
            }
            return false;
          }
          case "customer": {
            if (!searchValue) return false;
            const hasUnassigned = _.some(searchValue, ["_id", "unassigned"]);
            const customerIds = _.map(_.reject(searchValue, ["_id", "unassigned"]), "_id");
            const hasNoCustomer = _.isEmpty(event[typedKey]);
            return (
              (hasUnassigned && hasNoCustomer) || _.some(event[typedKey], (c: ICustomer) => customerIds.includes(c._id))
            );
          }
          case "flightType": {
            const eventColorArray = searchValue?.map((event: IFlightType) => event.color);
            return eventColorArray?.includes(event[typedKey]?.color);
          }
          case "aircraft": {
            if (!searchValue) {
              return null;
            }
            const aircraftRegArray = searchValue?.map((ac: IFlightAircraft) => ac.registration);
            const aircraftReg = event[key]?.registration ? event[key].registration : "Unassigned";
            return aircraftRegArray?.includes(aircraftReg);
          }
          default:
            return false;
          case "aircraftType": {
            const aircraftTypeArray = searchValue?.map((aircraftType: IAircraftType) => aircraftType.title);
            return event?.aircraft?.aircraftType && aircraftTypeArray?.includes(event.aircraft.aircraftType.title);
          }
          case "flags": {
            const flightFlagArray = searchValue?.map((flags: IFlightFlag) => flags.description);
            return event[typedKey]
              ? event[typedKey].find((flags: IFlightFlag) => flightFlagArray?.includes(flags.description))
              : false;
          }
          case "batchId":
            return !!searchValue && Array.isArray(searchValue) && typeof event[typedKey] === "string"
              ? searchValue.includes(event[typedKey])
              : false;
          case "createdBy":
          case "modifiedBy": {
            const userIdArray = searchValue?.map((user: IUser) => user._id);
            return userIdArray?.includes(event[key]);
          }
        }
      } else {
        switch (
          key // GROUND EVENT
        ) {
          case "location": {
            const airportIdentArray = searchValue?.map((airport: IAirportOption) => airport.ident);
            return airportIdentArray?.includes(event[typedKey].toString());
          }
          case "scheduledStart":
          case "scheduledEnd":
          case "actualStart":
          case "actualEnd":
          case "createdAt":
          case "modifiedAt": {
            const dateValue = new Date(event[typedKey]);
            const { minTime, maxTime } = searchValue;
            if (minTime && maxTime) {
              return dateValue >= new Date(minTime) && dateValue <= new Date(maxTime);
            } else if (minTime && !maxTime) {
              return dateValue >= new Date(minTime);
            } else if (!minTime && maxTime) {
              return dateValue <= new Date(maxTime);
            }
            return false;
          }
          case "customer": {
            if (!searchValue) return false;
            const hasUnassigned = _.some(searchValue, ["_id", "unassigned"]);
            const customerIds = _.map(_.reject(searchValue, ["_id", "unassigned"]), "_id");
            const hasNoCustomer = _.isEmpty(event[typedKey]);
            return (
              (hasUnassigned && hasNoCustomer) || _.some(event[typedKey], (c: ICustomer) => customerIds.includes(c._id))
            );
          }
          case "eventType": {
            const eventColorArray = searchValue?.map((event: IFlightType) => event.color);
            return eventColorArray?.includes(event[typedKey].color);
          }
          case "batchId":
            return !!searchValue && Array.isArray(searchValue) && typeof event[typedKey] === "string"
              ? searchValue.includes(event[typedKey])
              : false;
          case "createdBy":
          case "modifiedBy": {
            const userIdArray = searchValue?.map((user: IUser) => user._id);
            return userIdArray?.includes(event[typedKey]);
          }
          case "aircraft": {
            if (!searchValue) {
              return null;
            }
            const aircraftRegArray = searchValue.map((ac: IFlightAircraft) => ac.registration);
            const aircraftReg = event[key]?.registration ? event[key].registration : "Unassigned";
            return aircraftRegArray?.includes(aircraftReg);
          }
          default:
            return false;
        }
      }
    });
  }
  // update parent component.
  return newFilteredEvents;
};

export const filterContent = (filters: any, events: TimelineEvent[]): TimelineEvent[] => {
  // Set default sets to their searched event list.
  let newFilteredEvents: TimelineEvent[] = events;

  // If there are no filters containing values, or no data to filter, return
  if (!filters || Object.keys(filters).length === 0 || newFilteredEvents.length === 0) {
    return [];
  }

  for (const key in filters) {
    // const searchValue = filters[key];
    if (!key || !filters) {
      return [];
    }

    newFilteredEvents = newFilteredEvents.filter((event: IFlight | IGroundEvent) => {
      return true;
    });
  }
  return newFilteredEvents;
};
